module.exports = __webpack_public_path__ + "img/DE01763.35876974.svg";